export const emptyProfileModel = {
  isProfileCompleted: false,
  profileCreationCurrentStep: '0',
  profession: {
    name: '',
    years_experience: 0
  },
  job_title: '',
  location: {
    current: '',
    open_move: false,
    undisclosed: false
  },
  industries: {
    current: []
  },
  skills: [],
  education: {
    degrees: [],
    certifications: []
  },
  companies: [],
  accomplishments: [],
  bio: ''
};
